<template>
    <!-- eslint-disable vue/no-parsing-error -->
    <div style="min-height: 72.8vh;">
        <h2 style="height: 50px;">{{titleName()}}</h2>
        <!-- <div class="flex-content">
            <swiper ref="myswiper" class="swiper" :options="swiperOption">
                <swiper-slide :class="item.showbuybtn?'swiper-slide-check':'swiper-slide-default'" v-for="item in productsList" :key="item.code">
                    <div class="flex-content-card" :style="{opacity:item.lightup? 1 :0.6}">
                        <Card bordered class="mycard" style="overflow: hidden;">
                            <div v-if="item.publishstate===2" class="actionTitle" />
                            <div v-else class="actionTitle2" />
                            <div v-if="item.publishstate===2" class="actionText">
                                <span>正在</span>
                                <br />
                                <span>热售</span>
                            </div>
                            <div v-else-if="item.publishstate===3" class="actionText">
                                <span>尚未</span>
                                <br />
                                <span>销售</span>
                            </div>
                            <div v-else-if="item.publishstate===1" class="actionText">
                                <span>销售</span>
                                <br />
                                <span>满额</span>
                            </div>
                            <div slot="title" class="card-hearder-content">
                                <p class="card-title">{{item.name}}</p>
                                <p class="card-price">{{item.pricedesc}}</p>
                                <p class="card-explain">元 / 年</p>
                                
                                <div v-if="item.buybtntext==='续费'" class="card-btn-main">
                                      <Button v-if="item.showbuybtn" type="success" size="small" class="card-btn" :data-code="item.id" :style="{'margin-right':'5px'}" @click="showRenewalModal(item)">{{item.buybtntext}}</Button>
                                </div>
                                <div v-else class="card-btn-main">
                                    <Button v-if="item.showbuybtn" type="primary" size="small" class="card-btn" :data-code="item.code" :style="{'margin-right':'5px'}" @click="goPurchase(item)">
                                         <span>{{item.buybtntext}}</span>
                                    </Button>
                                </div>
                                <Tooltip content="名额递减中" :disabled="!item.isEnable" style="width: 100%">
                                    <Progress :percent="item.totalProgress" status="active" hide-info v-show="item.isEnable" :stroke-color="['#ff9569','#e92758']">
                                    </Progress>
                                </Tooltip>
                            </div>
                            <div class="card-body" v-for="(list,index) in item.BasePackageFun" :key="index">
                                <span>
                                    <Tag v-if="list.code==='000009'" color="green">{{ list.alias }}</Tag>
                                    <Tag v-else color="orange">{{ list.alias }}</Tag>
                                </span>
                                <Icon type="ios-checkmark" color="#2d8cf0" size="20" />
                            </div>
                        </Card>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div  v-if="productsList&&productsList.length>3"  style="text-align:center;"><Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="slidePrev">上一页</Button>
            <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="slideNext">下一页</Button></div> -->
        <div style="width:70%;margin:0 auto;">
            <div v-if="getUserId.length>0">
                <div v-if="isBuy===1">
                    <MemberLV ref='mymemberlevel' @payComplete="reloadmyproduct" />
                </div>
                <div v-else-if="isBuy===2" style="width:80%;margin:0 auto;" v-else>
                    <RenewLV ref="myrenewlevel" @payComplete="reloadmyproduct" />
                    <Button type="primary" size="default" style="float:right;margin-right: 35px;" @click="commitRenewalData">去支付</Button>
                </div>
                <div v-else>
                </div>
            </div>
            <div v-else></div>
        </div>
        <!--  <Modal v-model="modalPurchase" :mask-closable="false" :styles="{top: '20px'}" footer-hide width=850 @on-cancel="cancelPurchase">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>购买账号等级</span>
            </p>
            <Card class="pay-content" id="paycard" style="border:1px solid #d6bb5c;">
                <div slot="title">
                    <p class="pay-title">{{currentPurchaseData?currentPurchaseData.name:''}}</p>
                    <p class="card-explain" style="color:#808695">{{currentPurchaseData?currentPurchaseData.desc:''}}</p>
                </div>
                <div style="display: inline-block;">
                    <Row style="background:white;padding:20px 20px 20px 10px;">
                        <Col v-for="item in cardOptions" :span="cardOptions.length===3?'7':cardOptions.length===2?'11':cardOptions.length===1?'24':'24'" :key="item.discountcode" offset="1">
                        <div :class="item.selected?'optionscard-select':'optionscard'" @click="cardSelect(item.discountcode)">
                            <div style="font-size:16px;font-weight: bold;color:#17233d;text-align: center;">{{item.salenumber}}年</div>
                            <div style="font-size:12px;color:#ed4014;">{{item.discountname}}</div>
                            <div style="height:1px;line-height: 1px;background-color:#dcdee2;margin:5px 0px;"></div>
                            <div style="font-size:14px;color:#ed4014;">
                                <span style="font-size: 14px;">{{item.discountdesc}}</span>
                            </div>
                            <Icon color="#19be6b" size="16" class="select-icon" type="md-checkmark-circle" :style="{display:item.selected?'block':'none'}" />
                        </div>
                        </Col>
                    </Row>
                </div>
                <div class="divline">
                    <span class="divtxt">配置</span>
                </div>
                <p class="pay-explain" style="font-size: 14px;">
                    <div v-if="modalPurchase" style="padding:5px;margin: 0px 30px;">
                        <div v-for="(list,index) in currentPurchaseData.BasePackageFun" :key="index" style="float: left;">
                            <Tag size="medium" v-if="list.code==='000009'" color="green">{{ list.alias }}</Tag>
                            <Tag size="medium" v-else color="orange">{{ list.alias }}</Tag>
                        </div>
                    </div>
                </p>
            </Card>
            <div class="pay-change">
                <p style="height:30px;">支付方式</p>
                <RadioGroup v-model="payChange">
                    <Radio label="微信" border>
                        <i class="iconfont" style="color: #19c105;">&#xe650;</i>
                        <span style="color: #19c105;">微信</span>
                    </Radio>
                </RadioGroup>
            </div>
            <div class="invoiceContent">
                <span>发票信息：</span>
                <span v-if="invoiceType===1">普通发票</span>
                <span v-else-if="invoiceType===2">增值税专用发票</span>
                <span>{{sonheadertype===1?'个人':'单位'}}</span>
                <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="showInvoice">修改</Button>
            </div>
            <Divider orientation="right">优惠信息</Divider>
            <div style="text-align:right;padding-right: 15px;height: 160px;">
                <Coupon ref="mycoupon" @on-check="onCouponChecked" :isCouponShow="this.currentPurchaseData&&this.currentPurchaseData.code==='000001'?false:true" :isAgentShow=true />
            </div>
            <div style="color:red;font-size: 18px;text-align: right;margin-right: 25px;margin-top: 10px;display: block;">
                <span>实际支付:{{totalBill}}元</span>
                <Button type="primary" class="pay-btn" @click="directPay">去支付</Button>
            </div>
        </Modal> -->
        <Modal v-model="modalPay" width="700" :footer-hide="true" :mask-closable="false" class="vipmodal" @on-cancel="closeQRPay">
            <p slot="header" style="color:brown;text-align:center;font-size:16px;">
                <span>支付</span>
            </p>
            <div style="text-align: center;font-size: 18px;padding-top: 10px;">
                <div v-if="payChange==='微信'">
                    <i class="iconfont" style="color: #19c105;">&#xe650;</i>
                    <span style="color: #19c105;">微信支付</span>
                </div>
                <div v-else>
                    <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
                    <span style="color: #00aaee;">支付宝支付</span>
                </div>
            </div>
            <p style="text-align: center;color:#ed4014;font-size: 20px;">实付金额:{{totalBill}}元</p>
            <div v-if="orderState===0" style="width:100%;text-align: center;">
                <p style="width:100%;text-align: center;">订单编号:{{orderid}}</p>
                <div id="maskqr" style="position: relative;">
                    <img :src="base64str" class="qr-code-img"></img>
                    <Spin size="large" fix v-if="!agreementChecked"></Spin>
                </div>
                <div class="agreement-content">
                    <Checkbox style="margin-right: 0px;" v-model="agreementChecked">我已认真阅读并同意用户协议</Checkbox>《<span class="agreement-user" @click="showAgreement">用户协议</span>》
                </div>
                <br />
                <p style="width:100%;text-align: center;">请于5分钟内完成支付,逾期订单失效</p>
                <br />
            </div>
            <div v-else-if="orderState===100" style="width:100%;text-align: center;">
                <p>
                    <Icon size="50" type="md-checkmark-circle" color="#19be6b" />
                </p>
                <p style="width:100%;text-align: center;font-size: 20px;">您的订单支付成功</p>
                <p style="width:100%;text-align: center;padding-top: 40px;"><Button type="success" style="width:200px;" @click="closeQRPay">确定</Button></p>
                <br />
                <p style="width:100%;text-align: center;font-size: 14px;">支付窗口将于{{totalSec}}秒后关闭</p>
            </div>
            <div v-else style="width:100%;text-align: center;">
                <p>
                    <Icon size="50" type="md-alert" color="#ff9900" />
                </p>
                <p style="width:100%;text-align: center;font-size: 20px;">订单支付失败:{{payErrDesc}}</p>
                <br />
            </div>
        </Modal>
        <!-- <Modal v-model="modalInvoice" width="700" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>修改发票信息</span>
            </p>
            <div>
                <Invoice ref='myInvoice' :isModal="true" />
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelInvoice">取消</Button>
                <Button type="primary" size="large" @click="getInvoiceInfo">提交</Button>
            </div>
        </Modal> -->
        <Agreement ref="product_agreement" :isConfirm="true" @onAccept="onAgreementAccept" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ProductAgreement from './product_agreement.vue'
import invoice from './myinvoice.vue'
import coupon from './coupon.vue'
import mlevel from './myuserlevel.vue'
import renewmlevel from './product_renew.vue'
import eventBus from "../../components/common/event_bus.js"
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            isBuy: 0,//1="立即购买" 2="续费" 3="团购自用用户"
            select_item: {},
            title_name: '升级到种子用户，尊享账号等级配置权益',
            memberLevelChkInfo: null,
            oriprice: 0,
            myProducts: [],
            promocode: {
                couponcode: '',
                agentcode: '',
            },
            sonheadertype: 1,
            myInvoiceHeader: {
                bankaccount: "",
                bankname: "",
                headercode: "",
                headername: "个人",
                headertype: 1,
                invoiceTotal: 0,
                mobilenumber: "",
                officeaddress: "",
                postaddress: "",
                postemail: "",
                postmobile: "",
            },
            modalInvoice: false,
            invoiceType: 1,
            invoiceHeaderName: '个人',
            packageId: '',
            totalSec: 0,
            payErrDesc: '',
            isPaySuccess: false,
            isQueryPayState: false,
            orderState: 0,
            orderid: '',
            base64str: '',
            currentDiscountData: null,
            totalBill: 0,
            modalPay: false,
            payTime: 1,
            discount: 1,
            isOptionsCardSelect: false,
            agreementChecked: true,
            payChange: '微信',
            currentPurchaseData: {},
            modalPurchase: false,
            formItem: {},
            showSwiperBtn: false,
            shopCart: {},
            productsList: [],
            shopList: [{
                    id: '20001',
                    name: '201',
                    title: '全国版种子用户',
                    desc: '低至1元/天',
                    otherdesc: '持续续费,尊享赠送权益',
                    price: 1,
                    number: 1,
                    total: 0,
                    class: 0,
                    remainingday: 365,
                    orderNumber: 0,
                    orderYears: 1,
                    totalProgress: 40,
                    selected: false,
                    isPurchased: false,
                    isEnable: true,
                    expirationDate: '',
                    gifts: ['地方版', '智慧云端', '我的秘书', '税收优惠检索', '条约检索', '行业检索', '进出口税收检索', '移动云擎', '一键上传']

                },
                {
                    id: '20002',
                    name: '202',
                    title: '全国版钻石用户',
                    desc: '低至2元/天',
                    otherdesc: '',
                    price: 2,
                    number: 1,
                    total: 0,
                    class: 0,
                    remainingday: 365,
                    orderNumber: 0,
                    orderYears: 1,
                    totalProgress: 40,
                    selected: false,
                    isPurchased: false,
                    isEnable: false,
                    expirationDate: '',
                    gifts: ['地方版', '智慧云端', '我的秘书', '税收优惠检索', '条约检索', '行业检索', '进出口税收检索', '移动云擎']

                },
                {
                    id: '20003',
                    name: '203',
                    title: '全国版黄金用户',
                    desc: '低至3元/天',
                    otherdesc: '',
                    price: 3,
                    number: 1,
                    total: 0,
                    class: 0,
                    remainingday: 365,
                    orderNumber: 0,
                    orderYears: 1,
                    totalProgress: 40,
                    selected: false,
                    isPurchased: false,
                    isEnable: false,
                    expirationDate: '',
                    gifts: ['地方版', '智慧云端', '我的秘书', '税收优惠检索', '条约检索', '行业检索', '进出口税收检索', '移动云擎']

                },
                {
                    id: '20004',
                    name: '204',
                    title: '全国版白银用户',
                    desc: '低至4元/天',
                    otherdesc: '',
                    price: 4,
                    number: 1,
                    total: 0,
                    class: 0,
                    remainingday: 365,
                    orderNumber: 0,
                    orderYears: 1,
                    totalProgress: 40,
                    selected: false,
                    isPurchased: false,
                    isEnable: false,
                    expirationDate: '',
                    gifts: ['地方版', '智慧云端', '我的秘书', '税收优惠检索', '条约检索', '行业检索', '进出口税收检索', '移动云擎']

                },
                {
                    id: '20005',
                    name: '205',
                    title: '全国版白银用户',
                    desc: '低至5元/天',
                    otherdesc: '',
                    price: 5,
                    number: 1,
                    total: 0,
                    class: 0,
                    remainingday: 365,
                    orderNumber: 0,
                    orderYears: 1,
                    totalProgress: 40,
                    selected: false,
                    isPurchased: false,
                    isEnable: false,
                    expirationDate: '',
                    gifts: ['地方版', '智慧云端', '我的秘书', '税收优惠检索', '条约检索', '行业检索', '进出口税收检索', '移动云擎']

                }
            ],
            swiperOption: {
                // loop:true,
                // loopFillGroupWithBlank:true,
                simulateTouch: false,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                slidesPerView: 3,
                centerInsufficientSlides: true,
                spaceBetween: 20,
                //slidesPerGroup: 4,
                disabledClass: 'my-button-disabled',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                    // type: 'custom',
                    // renderCustom: function(swiper, current, total) {
                    //     return '第' + current + '页 共' + total + '页';
                    // }
                },
                //initialSlide: 1,
            },
            cardOptions: [],
            // cardOptions: [
            //     {
            //         id: '90001',
            //         title: '一年',
            //         price: 365,
            //         time: 1,
            //         discount: 1,
            //         selected: true,
            //     },
            //     {
            //         id: '90002',
            //         title: '两年',
            //         price: 365,
            //         time: 2,
            //         discount: 0.95,
            //         selected: false,
            //     }, 
            //     {
            //         id: '90003',
            //         title: '三年',
            //         price: 365,
            //         time: 3,
            //         discount: 0.9,
            //         selected: false,
            //     }
            // ]

        }
    },
    mounted() {},
    created() {
        //this.getProducts()
        if (this.checkUserLogin()) {
            this.getProducts()
        }
    },
    components: {
        'Agreement': ProductAgreement,
        'Invoice': invoice,
        'Coupon': coupon,
        'MemberLV': mlevel,
        "RenewLV": renewmlevel,
    },
    computed: {
        countDays() {
            return function(data) {
                let per = 0
                if (data) {
                    per = data.remainingday / 365 * 100
                }
                console.log(per)
                return per
            }
        },
        ...mapGetters(['getUserId']),
        ...mapGetters(['sta']),
        //判断是否显示购买按钮，当productcode不一致的时候
        isShow() {
            return function(item) {
                if (item.publishstate === 2 &&
                    (this.sta.accounttype === 1) &&
                    (this.sta.accountstatus === 400 || this.sta.accountstatus === 300)
                ) {
                    return true
                } else if (item.publishstate === 2 &&
                    (this.sta.accounttype === 1) &&
                    (this.sta.accountstatus === 100 || this.sta.accountstatus === 107)
                ) {
                    return true
                } else if (item.publishstate === 2 &&
                    (this.sta.accounttype === 4)
                ) {
                    return true
                } else {
                    return false
                }
            }
        },
        //以前的逻辑，判断是否点亮
        isShowPublish() {
            return function(item) {
                if (item.publishstate === 2) {
                    return true
                } else if (item.publishstate === 1) {
                    if (
                        // this.sta.accounttype === 1 &&
                        // this.sta.accountstatus !== 300 &&
                        // this.sta.accountstatus !== 400 &&
                        this.packageId === item.code) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }

            }

        },
        titleName() {
            return function() {
                if (this.sta.accounttype === 4) {
                    return "系统已匹配出您可以续购的账号等级"
                } else if (this.sta.accounttype === 2 || this.sta.accounttype === 3) {
                    return "请与单位管理员联系"
                }
                // else if (this.sta.accountstatus === 400) {
                //     return "冻结期续费，重新匹配您可购买的账号等级"
                // } 
                else if (this.sta.accountstatus === 200 || this.sta.accountstatus === 207) {
                    return "持续续费，尊享账号等级配置权益"
                } else if (this.sta.accountstatus === 100 || this.sta.accountstatus === 107 || this.sta.accountstatus === 300 || this.sta.accountstatus === 400) {
                    return "购买账号等级，尊享账号等级配置权益"
                }
            }
        }

    },
    watch: {

    },
    methods: {
        // timeFormat(param) {
        //     return param < 10 ? '0' + param : param;
        // },
        // restTime() {
        //     //let order_time=moment('2020-09-15 14:39:00').valueOf()
        //     let order_time =  new Date()
        //     let that = this
        //     let interval = setInterval(() => {
        //         console.log('resttime---->')
        //         let orderTime = order_time
        //         let setTime = new Date(orderTime)
        //         let nowTime = new Date()
        //         let restTime = nowTime.getTime() - setTime.getTime()
        //         // let hour =  parseInt(restTime/(60*60*1000) % 60)
        //         let minu = parseInt(restTime / (60 * 1000) % 60)
        //         let second = parseInt(restTime / 1000 % 60)
        //         let realmin = 5 - minu
        //         let realsecond = 60 - second
        //         let obj = {
        //             min: that.timeFormat(realmin),
        //             second: that.timeFormat(realsecond),
        //         }
        //         that.countdown = '00:' + obj.min + ':' + obj.second
        //     }, 1000)

        // },
        commitRenewalData() {
            this.$refs.myrenewlevel.checkOrder()
        },
        reloadmyproduct() {
            console.log("reloadmyproduct==========================>")
            if (this.checkUserLogin()) {
                this.getProducts().then(res => {
                    //通知top_header刷新用户数据/权限
                    console.log('通知top_header刷新用户数据/权限===>')
                    setTimeout(() => {
                        eventBus.$emit('user-flashToken')
                    }, 3000);

                })
            }
        },
        showCouponPrice(value) {
            this.totalBill = value.item.amount
            this.oriprice = value.item.oriamount
            // this.newprice=value.item.amount
            console.log(value)
        },
        onCouponChecked(chkinfo) {
            this.memberLevelChkInfo = chkinfo
            if (chkinfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.totalBill, this.showCouponPrice)
            } else {
                this.$refs.mycoupon.clean()
                this.goPurchase(this.currentPurchaseData)
            }
        },
        onAgreementAccept() {
            console.log("onAgreementAccept======>")
        },
        slideNext() {
            this.$refs.myswiper.swiper.slideNext()
        },
        slidePrev() {
            this.$refs.myswiper.swiper.slidePrev()
        },
        cancelPurchase() {
            this.$refs.mycoupon.clean()
        },
        cancelInvoice() {
            this.modalInvoice = false
        },
        getInvoiceInfo() {
            this.$refs.myInvoice.$refs.formData.validate((valid) => {
                if (valid) {
                    if (this.$refs.myInvoice.formData.headertype == 1) {
                        this.$refs.myInvoice.formData.headercode = ''
                        this.$refs.myInvoice.formData.officeaddress = ''
                        this.$refs.myInvoice.formData.mobilenumber = ''
                        this.$refs.myInvoice.formData.bankname = ''
                        this.$refs.myInvoice.formData.bankaccount = ''
                        // this.$refs.myInvoice.formData.postaddress = ''
                        // this.$refs.myInvoice.formData.postemail = ''
                        // this.$refs.myInvoice.formData.postmobile = ''
                    }
                    this.sonheadertype = Number(this.$refs.myInvoice.formData.headertype)
                    console.log(this.sonheadertype);
                    this.$refs.myInvoice.remData = JSON.parse(JSON.stringify(this.$refs.myInvoice.formData))
                    this.$refs.myInvoice.remheadertype = this.$refs.myInvoice.formData.headertype
                    let _invoiceType = this.$refs.myInvoice.invoicetype
                    let invoiceHeader = { ...this.$refs.myInvoice.formData }
                    // this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
                    this.invoiceHeaderName = this.$refs.myInvoice.formData.headertype == 1 ? '个人' : '单位'
                    this.invoiceType = Number(_invoiceType)
                    this.myInvoiceHeader = invoiceHeader
                    this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
                    this.modalInvoice = false
                    // console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
                } else {
                    this.$Message.error('请填写必填项！');
                    return
                }
            })

        },
        // getInvoiceInfo() {
        //     let _invoiceType = this.$refs.myInvoice.invoicetype
        //     let invoiceHeader = { ...this.$refs.myInvoice.formData }
        //     this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
        //     this.invoiceType = Number(_invoiceType)
        //     this.myInvoiceHeader = invoiceHeader
        //     this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
        //     this.modalInvoice = false

        //     console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
        // },
        showInvoice() {
            this.modalInvoice = true
            this.$refs.myInvoice.invoicetype = '1'
            this.$refs.myInvoice.invoiceTotal = this.totalBill
        },
        showAgreement() {
            this.$refs.product_agreement.show()
        },
        checkUserLogin() {
            let value = this.getUserId
            if (value && value.length > 0) {
                return true
            } else {
                return false
            }
        },
        autoClose() {
            this.totalSec = 5
            let that = this
            let clock = window.setInterval(() => {
                console.log('di--->')
                if (that.totalSec === 0) {
                    that.closeQRPay()
                    window.clearInterval(clock)
                    return
                } else {
                    that.totalSec--
                }

            }, 1000)
        },
        getProducts() {
            //store.state.user.accounttype=3
            console.log('store.state.user.accounttype' + store.state.user.accounttype)
            console.log('getProducts==========>')
            return new Promise((resolve, reject) => {
                constJ.reqGetProducts().then(res => {
                    console.log(res)
                    if (res.rltcode === 1 && res.rtncode === 1) {
                        this.productsList = res.data.products
                        //写死测试
                        //this.productsList[0].publishstate=1
                        //this.productsList[1].publishstate=2
                        store.state.user.myvippackage = res.data.effectiveorders.length > 0 ? res.data.effectiveorders : []
                        // store.state.user.myfreezeorders = res.data.freezeorders && res.data.freezeorders.length > 0 ? res.data.freezeorders : []
                        let len = store.state.user.myvippackage.length
                        if (len > 0) {
                            //this.packageId = store.state.user.myvippackage[0].productcode
                            this.packageId = store.state.user.myvippackage[len - 1].productcode
                        }
                        // else if (store.state.user.myfreezeorders.length > 0) {
                        //     this.packageId = store.state.user.myfreezeorders[0].productcode
                        // }
                        this.checkIsVip()

                        //判断续费还是购买
                        let operItem = this.productsList.find(p => p.showbuybtn === true)
                        if (operItem) {
                            if (operItem.buybtntext === '立即购买') {
                                this.isBuy = 1
                                //购买
                                this.goPurchase1(operItem)
                            } else if (operItem.buybtntext === '续费') {
                                this.isBuy = 2
                                //续费
                                this.getMyProducts1()

                            } else {

                            }
                        } else {
                            //团购自用

                            this.isBuy = 3
                            this.$emit('isTeamUser')
                        }
                        console.log("this.isbuy:"+this.isBuy)
                        resolve(res)
                    } else {
                        this.$Message.warning(res.rtndesc)
                        return
                    }
                }).catch(function(err) {
                    reject(err)
                })
            })

        },
        getMyProducts1() {
            //获取已购产品
            constJ.reqGetUserProduct().then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    if (res.items) {
                        this.myProducts = res.items
                        if (this.myProducts.length > 0) {
                            let row = this.myProducts[0]
                            console.log(row)
                            this.$refs.myrenewlevel.loadDefaultPackages(row)
                            //eventBus.$emit("user-renewal", row)
                        } else {
                            this.$Message.wwarning('读取我的产品列表数据异常，续费失败')
                            return
                        }

                    } else {
                        this.myProducts = []
                        this.$Message.wwarning('我的产品列表数据异常，续费失败')
                        return
                    }
                }
            })
        },
        // getMyProducts() {
        //     //获取已购产品
        //     constJ.reqGetUserProduct().then(res => {
        //         console.log(res)
        //         if (res.rltcode === 1 && res.rtncode === 1) {
        //             if (res.items) {
        //                 this.myProducts = res.items
        //                 if (this.myProducts.length > 0) {
        //                     let row = this.myProducts[0]
        //                     console.log(row)
        //                     eventBus.$emit("user-renewal", row)
        //                 } else {
        //                     this.$Message.wwarning('读取我的产品列表数据异常，续费失败')
        //                     return
        //                 }

        //             } else {
        //                 this.myProducts = []
        //                 this.$Message.wwarning('我的产品列表数据异常，续费失败')
        //                 return
        //             }
        //         }
        //     })
        // },
        // showRenewalModal(item) {
        //     // console.log('2==============2')
        //     //this.select_item=item
        //     // console.log(this.select_item)
        //     this.getMyProducts()
        //     // console.log('emit->user-renewal')
        //     // eventBus.$emit("user-vipboard")

        // },
        checkIsVip() {
            console.log('checkVip=====>')
            let vipData = store.state.user.myvippackage
            //console.log(vipData)
            if (vipData && vipData.length > 0) {
                //vip在有效期内
                console.log(vipData)
                this.$emit('check-vip', true)
            } else {
                this.$emit('check-vip', false)
            }

        },
        ////////////////////////////////////////////////////////////////////////////////////////
        getOrderState(orderid, clock) {
            let k = this.$Tools.getPayState()
            if (!this.isQueryPayState) {
                window.clearInterval(clock)
                return
            }
            constJ.reqGetOrderState(orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.orderState = res.status.paystatus
                    if (res.status.paystatus === k.PAYSTATUS_PAYEND) {
                        this.$Message.success('支付成功')
                        this.isPaySuccess = true
                        console.log("clearInterval...")
                        window.clearInterval(clock)
                        //刷新商城数据
                        if (this.checkUserLogin()) {
                            Promise.all([this.getProducts()]).then(res => {
                                //通知top_header刷新用户数据/权限
                                eventBus.$emit('user-flashToken')
                            });
                        }
                        //关闭倒计时
                        this.autoClose()
                        //this.closeQRPay()
                        return
                    } else if (res.status.paystatus === k.PAYSTATUS_WAITINGPAY) {
                        //this.$Message.warning(res.status.paystatusdesc)
                    } else if (res.status.paystatus < 0) {
                        this.$Message.warning(res.status.paystatusdesc)
                        this.payErrDesc = res.status.paystatusdesc
                        window.clearInterval(clock)
                        return
                    }
                } else {
                    if (res.rltcode < 0) {
                        this.$Message.warning(res.rltdesc)
                        window.clearInterval(clock)
                        return
                    } else if (res.rtncode < 0) {
                        this.$Message.warning(res.rtndesc)
                        window.clearInterval(clock)
                        return
                    }
                }
            })
        },
        checkOrderPayState(orderid) {
            let clock = window.setInterval(() => {
                this.getOrderState(orderid, clock)
            }, 2000)


        },

        closeQRPay() {
            this.isQueryPayState = false
            this.modalPay = false
        },
        paySuccess() {
            // console.log(this.currentPurchaseData)
            // this.modalPay = false
            // this.$Message.success('支付成功')
            // //暂存store
            // let ar = []
            // ar.push(this.currentPurchaseData)
            // store.state.user.myvippackage = ar
            // this.checkIsVip()
            // //支付成功,清空购物车
            // this.$emit('cleanCart')
            let orderid = this.orderid
            if (orderid === '') {
                this.$Message.warning('获取订单信息异常')
                return
            }
            this.closeQRPay()
        },
        //////////////////////////////////////////////////////////////////////////////////////

        cardSelect(id) {
            console.log('cardSelect======>')

            // this.cardOptions.forEach(function(item) {
            //     item.selected = false
            // })
            // const findelement = this.cardOptions.find(element => element.id === id)
            // findelement.selected = true
            // this.payTime = findelement.time
            // this.discount = findelement.discount
            // this.currentPurchaseData.remainingday = 365 * this.payTime
            // this.currentPurchaseData.orderYears = this.payTime
            // this.currentPurchaseData.expirationDate = moment().add(this.currentPurchaseData.remainingday, 'days').format("YYYY-MM-DD");
            console.log(id)
            this.cardOptions.forEach(function(item) {
                item.selected = false
            })
            const findelement = this.cardOptions.find(element => element.discountcode === id)
            findelement.selected = true
            let _index = this.cardOptions.findIndex(element => element.discountcode === id)
            this.$set(this.cardOptions, _index, findelement)
            console.log(findelement)
            this.totalBill = findelement.newprice
            this.oriprice = findelement.oriprice
            this.currentDiscountData = findelement

            //切换账号等级年限
            if (this.memberLevelChkInfo && this.memberLevelChkInfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.totalBill, this.showCouponPrice)
            }
            //console.log(this.cardOptions)

        },
        goPurchase1(item) {
            console.log(item)
            let current_product = null
            let pkg = JSON.stringify(item)
            current_product = JSON.parse(pkg)
            this.currentPurchaseData = current_product
            let code = item.code
            var that = this
            constJ.reqProductDiscountList(code).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.cardOptions = res.item
                    if (!this.cardOptions) {
                        this.$Message.warning('无产品优惠信息！')
                        return
                    }

                    this.cardOptions[0].selected = true
                    this.totalBill = this.cardOptions[0].newprice
                    this.oriprice = this.cardOptions[0].oriprice
                    this.currentDiscountData = this.cardOptions[0]

                    //购买
                    this.$refs.mymemberlevel.show(this.currentPurchaseData, this.cardOptions)
                    //this.modalPurchase = true
                    //读取发票信息
                    //this.$refs.myInvoice.getInvoice()
                    //this.$refs.myInvoice.invoiceTotal=this.totalBill
                }
            })


        },
        goPurchase(item) {
            // let current_product =null
            // let pkg = JSON.stringify(item)
            // current_product = JSON.parse(pkg)
            // this.currentPurchaseData = current_product
            // this.currentPurchaseData.expirationDate=moment().add(item.orderYears*365, 'days').format("YYYY-MM-DD");
            // console.log(this.currentPurchaseData)



            console.log(item)
            let current_product = null
            let pkg = JSON.stringify(item)
            current_product = JSON.parse(pkg)
            this.currentPurchaseData = current_product
            let code = item.code
            var that = this
            constJ.reqProductDiscountList(code).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //定义直接购买的选项数据items

                    // //测试
                    // let k=[]
                    // let i = 0
                    // res.item.forEach(function(item){
                    //     if(i<3){
                    //         k.push(item)
                    //         i++
                    //     }

                    // })
                    // console.log(k)
                    // //测试end

                    this.cardOptions = res.item
                    if (!this.cardOptions) {
                        this.$Message.warning('无产品优惠信息！')
                        return
                    }

                    // this.cardOptions.forEach(function(item) {
                    //     //优惠编码
                    //     if (item.discountcode === '000011') {
                    //         item.selected = true

                    //     } else {
                    //         item.selected = false
                    //     }
                    // })

                    this.cardOptions[0].selected = true
                    this.totalBill = this.cardOptions[0].newprice
                    this.oriprice = this.cardOptions[0].oriprice
                    this.currentDiscountData = this.cardOptions[0]


                    this.modalPurchase = true
                    //读取发票信息
                    this.$refs.myInvoice.getInvoice()
                    //this.$refs.myInvoice.invoiceTotal=this.totalBill
                }
            })
            //清空coupon信息
            this.$refs.mycoupon.clean()

        },
        //购物车支付
        cartPay(item, invoice) {
            let code = item.id
            let discountcode = ''
            let poData = {
                product: code,
                discount: '000001',
                paytype: 30,
                couponcode: item.promocode.couponcode,
                agentcode: item.promocode.agentcode,
                invoice: invoice,
            }
            this.totalBill = item.total
            constJ.reqCreateOrder(poData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {

                    //展示支付二维码
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    this.payChange = item.paychange
                    this.getOrderContract(this.orderid)

                    // this.modalPay = true
                    // this.modalPurchase = false

                    // //开启轮询
                    // this.isQueryPayState = true
                    // this.checkOrderPayState(this.orderid)
                } else if (res.rltcode === -200) {
                    //更新产品列表,当前产品已购买
                    console.log('您已购买过此产品')
                    return
                }
            })

        },
        directPay() {
            console.log('show qrcode')
            this.checkOrder()
            //this.showQRAndCheckPayStatus()
        },
        //下单前检查优惠码和运营商信息,可以强制下单
        checkOrder() {
            let r = this.$refs.mycoupon.getConfirmInfo()
            if (r.iswarning) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>' + r.rltdesc + '</p>',
                    cancelText: "返回",
                    okText: "下单",
                    onOk: () => {
                        this.takeOrder()
                    },
                    onCancel: () => {
                        return
                    }
                });
            } else {
                this.takeOrder()
            }
        },
        //用户等级包下单
        takeOrder() {
            // let total = this.currentPurchaseData ? (this.currentPurchaseData.price * this.currentPurchaseData.remainingday * this.discount).toFixed(2) : ''
            // this.totalBill = total
            console.log(this.currentPurchaseData)
            let product = this.currentPurchaseData
            let discountData = this.currentDiscountData
            this.promocode.couponcode = this.$refs.mycoupon.formCustom.couponValue
            this.promocode.agentcode = this.$refs.mycoupon.formCustom.agencies
            //console.log(product, discountData)
            let _invoice = {
                invoicetype: this.invoiceType,
                invoiceheader: this.myInvoiceHeader
            }
            let poData = {
                product: product.code,
                discount: discountData.discountcode,
                paytype: 30,
                couponcode: this.promocode.couponcode,
                agentcode: this.promocode.agentcode,
                invoice: _invoice,

            }
            //用户等级包下单
            constJ.reqCreateOrder(poData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //绑定支付二维码
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    this.totalBill = res.result.actualAmount
                    this.getOrderContract(this.orderid)

                } else {
                    //更新产品列表,当前产品已购买
                    this.$Message.warning(res.rltdesc)
                    //console.log('您已购买过此产品')
                    return
                }
            })


        },
        //获取合同信息
        getOrderContract(orderid) {
            //獲取合同信息
            console.log('合同orderid:' + orderid)
            constJ.reqGetOrderContract(orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.$refs.product_agreement.createdata(res.item)
                    this.showQRAndCheckPayStatus()
                }
            })
        },
        //支付二维码
        showQRAndCheckPayStatus() {
            this.modalPay = true
            this.modalPurchase = false
            //开启轮询
            this.isQueryPayState = true
            this.checkOrderPayState(this.orderid)
        },
        addToCart(row) {
            console.log(row)
            // this.shopList.map(item => {
            //     if (item.id == row.id) {
            //         this.shopCart = item
            //     }
            // })
            //this.shopCart = row
            this.shopCart.orderNumber = 1
            this.shopCart.title = row.name
            this.shopCart.desc = row.desc
            this.shopCart.id = row.code
            this.shopCart.remainingday = 365
            this.shopCart.pkgclass = 0
            this.shopCart.total = Number(row.pricedesc)
            console.log(this.shopCart);
            this.$emit('add-cart', this.shopCart)

        },

    }
}
</script>
<style lang="less" scoped>
@font-face {
    font-family: 'iconfont';
    /* project id 1804652 */
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
}

.iconfont {
    font-size: 16px;
    font-family: 'iconfont';
    margin-right: 10px;
}

.my-button-disabled {
    opacity: 0.1;
}

h2 {
    height: 75px;
    line-height: 50px;
    text-align: center;
}

.flex-content {
    display: flex;
    margin: 0 24.1%;
    padding: 5px;
    justify-content: space-evenly;

    // .swiper-pagination {
    //     position: static;
    //     margin-top: 10px;
    // }
}

.swiper-slide:first-child {
    //border: 2px solid #2d8cf0;
}

.swiper-slide-check {
    border: 2px solid #2d8cf0;
}

.swiper-slide-default {
    border: none;
}

.mycard:first-child {
    height: 480px !important;
}

.mycard/deep/.ivu-card-body {
    height: 290px !important;
    overflow-y: auto !important;
}

.card-hearder-content {
    height: 160px;
}

.card-title {
    text-align: center;
    line-height: 50px;
    font-size: 17px;
    color: #2d8cf0;
    height: 50px;
}

.card-price {
    text-align: center;
    line-height: 24px;
    font-size: 24px;
    color: #2d8cf0;
    height: 24px;
    color: #ed4014;
}


#paycard {
    background-color: #FEE5A7;
    overflow: hidden;
}

#paycard/deep/.ivu-card-head {
    /*border-bottom: 1px solid #e0cc98;*/
    border-bottom: none;
}

#paycard/deep/.ivu-card-body {
    padding: 0px !important;
}



.actionPayTitle {
    background-color: #F4C466;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 280px;
    left: 350px;
    /*border: 1px sloid red;*/
    border-radius: 0%;
    transform: translate(50px, 50px);
    -webkit-transform: rotate(45deg);
    z-index: 1;
}


.card-explain {
    text-align: center;
    line-height: 12px;
    font-size: 12px;
    height: 15px;
}

.card-btn-main {
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.card-body {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
}



.pay-content {
    border: 1px solid #ccc;
    margin: 1% 10%;
    padding: 1% 5%;
    text-align: center;
}

.pay-title {
    font-size: 20px;
    color: #f55d54;
    height: 30px;
}

.pay-change {
    text-align: center;
}

.pay-explain {
    height: 5px;
    font-size: 10px;
    line-height: 20px;
    text-align: center;
    margin-top: 0px;
}

.agreement-content {
    margin-top: 10px;
    font-size: 10px;
    text-align: center;
}

.agreement-user {
    font-size: 10px;
    color: #4386f5;
    cursor: pointer;
}

.pay-btn-content {
    margin-top: 30px;
    text-align: right;
    padding-right: 30px;
}

.pay-btn {
    margin-left: 20px;
}

.qr-code-content {
    text-align: center;
    height: 350px;
}

.qr-code-img {
    /*height: 256px;*/
    width: 256px;
    /*margin-bottom: 30px;*/
}

.qr-code-content-btn {
    display: flex;
    justify-content: space-evenly;
}

.swiper {
    width: 100%;
    height: 100%;
}

/* .swiper-slide {
  background-position: center;
  background-size: cover;
} */
.qr-pay-content {
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.qr-pay-content-text {
    font-size: 18px;
}

.swiper-button-prev,
.swiper-button-next {
    background-size: 15px;
}

//正在热售
.actionTitle {
    background-color: #FF4D60;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 0px;
    right: 0px;
    border: 1px sloid red;
    border-radius: 50%;
    transform: translate(50px, -50px);
}

.actionText {
    position: absolute;
    top: 0px;
    right: 5px;
    color: white;
}

//尚未销售
.actionTitle2 {
    background-color: #808695;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 0px;
    right: 0px;
    border: 1px sloid #515a6e;
    border-radius: 50%;
    transform: translate(50px, -50px);
}

.actionText2 {
    position: absolute;
    top: 0px;
    right: 5px;
    color: white;
}

.circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #1E90FF;
    margin-top: 3px;
}

.circle-text {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 12px;
    color: #ffffff;
    padding-top: 1px;
}

/*分割线*/
.divline {
    display: table;
    white-space: nowrap;
    text-align: center;
    background: 0 0;
    font-weight: 500;
    color: #17233d;
    font-size: 16px;
    margin: 6px 0;
}

.divline:before {
    content: '';
    display: table-cell;
    position: relative;
    top: 50%;
    width: 50%;
    border-top: 1px solid #ed4014;
    transform: translateY(50%);
}

.divline:after {
    content: '';
    display: table-cell;
    position: relative;
    top: 50%;
    width: 50%;
    border-top: 1px solid #ed4014;
    transform: translateY(50%);
}

.divtxt {
    display: inline-block;
    padding: 0 24px;
    font-size: 14px;

}

.optionscard {
    display: grid;
    border: 1px solid #dcdee2;
    padding: 20px;
    cursor: Pointer;

}

.optionscard-select {
    background-color: #FFF1F3;
    display: grid;
    border: 1px solid #ed4014;
    padding: 20px;
    cursor: Pointer;
}

.select-icon {
    position: absolute;
    bottom: 5px;
    left: 80%;
}

/*pay modal*/
.vipmodal/deep/.ivu-modal-body {
    padding: 0px;
}

.vipmodal/deep/.ivu-modal-header {
    background-color: #FEE7AA;
}


h2 {
    height: 75px;
    line-height: 50px;
    text-align: center;
}

.scentitle {
    font-size: 10px;
    color: #ccc;
    line-height: 50px;
    text-align: center;
}

.card-title-desc {
    font-size: 12px;
    color: #808695;
    height: 20px;
    line-height: 20px;
    margin-top: 5px;
}

/*发票信息*/
.invoiceContent {
    margin-top: 10px;
    text-align: center;
    padding-right: 22px;

    span {
        padding-left: 10px;
    }
}

#maskqr/deep/.ivu-spin-fix {
    background-color: rgba(255, 255, 255, 1);
}
</style>